import { MediaBox } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

import WizardHeaderLoading from "areas/product/jewlr/loaders/wizard-header-loading"

import Breadcrumbs from "./breadcrumbs"
import OutOfStockBanner from "./out-of-stock-banner"
import Title from "./title"

const InternalHeaderMobile = ({ outOfStock, outOfStockRef, wizardLoading }) => {
  return (
    <MediaBox lessThan="tablet" mb="25px" minHeight="62px" px="20px">
      {!wizardLoading ? (
        <>
          <Breadcrumbs />
          <Title />
          {outOfStock && <OutOfStockBanner outOfStockRef={outOfStockRef} />}
        </>
      ) : (
        <WizardHeaderLoading />
      )}
    </MediaBox>
  )
}

InternalHeaderMobile.propTypes = {
  outOfStock: PropTypes.bool,
  outOfStockRef: PropTypes.object,
  wizardLoading: PropTypes.string,
}

const mapDispatchToProps = (state) => {
  return {
    outOfStock: state.wizard.header?.product_out_of_stock,
    wizardLoading: state.wizard.loading,
  }
}

const HeaderMobile = connect(mapDispatchToProps, {})(InternalHeaderMobile)

export default HeaderMobile
